import { render } from "./MfactTabs.vue?vue&type=template&id=6d36039b"
import script from "./MfactTabs.vue?vue&type=script&lang=js"
export * from "./MfactTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__